import { useEffect, useState, useRef } from 'react';
import useLocalStorage from '../useLocalStorage/useLocalStorage';
import { Auth, recordHandler } from '../../config/configuration/react';

const useSource = () => {
  const userId = Auth.userId();
  const sourceId = Auth.sourceId();
  const [source, setSource] = useLocalStorage(`${userId}.sources`, []);
  const [isLoading, setisLoading] = useState(false);
  const [autoRefId, setAutoRefId] = useState(null);
  const isMounted = useRef(false);

  const getSource = async () => {
    if (source || !sourceId) return;
    setisLoading(true);
    try {
      const res = await recordHandler.getSource(sourceId);
      setAutoRefId(res?.sourceGroupData?.autoRefId);
      if (isMounted.current) return;
      setSource(res);
    } catch (e) {
      console.log('error loading source');
    } finally {
      if (!isMounted.current) {
        setisLoading(false);
      }
    }
  };

  useEffect(() => {
    getSource();
    return () => {
      isMounted.current = true;
    };
  }, [sourceId]);

  return { source, isLoading, autoRefId };
};

export default useSource;
